export const brandProductOptions = {
  "Golf Gods": [
    {
      label: "男生短袖",
      type: "apparel",
      options: [{ name: "尺寸", values: ["S", "M", "L", "XL", "2XL"] }],
    },
    {
      label: "男生長袖",
      type: "apparel",
      options: [{ name: "尺寸", values: ["S", "M", "L", "XL", "2XL"] }],
    },
    {
      label: "女生衣服",
      type: "apparel",
      options: [{ name: "尺寸", values: ["XS", "S", "M", "L", "XL"] }],
    },
    {
      label: "小孩衣服",
      type: "apparel",
      options: [{ name: "尺寸", values: ["4", "6", "8", "10", "12", "14"] }],
    },
    {
      label: "潮短褲",
      type: "apparel",
      options: [{ name: "尺寸", values: ["30", "32", "34", "36", "38", "40"] }],
    },
    {
      label: "騷短褲",
      type: "apparel",
      options: [{ name: "尺寸", values: ["30", "32", "34", "36", "38", "40"] }],
    },
    {
      label: "潮手套",
      type: "accessory",
      options: [
        {
          name: "尺寸",
          values: ["左手 S", "左手 M", "左手 ML", "左手 L", "左手 XL"],
        },
      ],
    },
    {
      label: "骷髏手套",
      type: "accessory",
      options: [
        {
          name: "尺寸",
          values: ["左手 S", "左手 M", "左手 ML", "左手 L", "左手 XL"],
        },
      ],
    },
    {
      label: "帽子",
      type: "accessory",
      options: [], // 無分男女無分尺寸
    },
    {
      label: "高爾夫球袋",
      type: "accessory",
      options: [],
    },
    {
      label: "球桿套",
      type: "accessory",
      options: [],
    },
    {
      label: "配件",
      type: "accessory",
      options: [],
    },
    {
      label: "高爾夫雪茄盒",
      type: "accessory",
      options: [{ name: "顏色", values: ["咖啡色", "黑色"] }],
    },
  ],
  Krank: [
    {
      label: "Pro款 (Pro)",
      type: "driver",
      options: [
        { name: "度數", values: ["9.0", "10.5"] },
        { name: "硬度", values: ["X", "S", "R"] },
        {
          name: "桿身",
          values: [
            "Fujikura Speeder X Tour (66克)",
            "Fujikura Speeder X Light Tour (54克)",
          ],
        },
      ],
    },
    {
      label: "標準款 (X)",
      type: "driver",
      options: [
        { name: "度數", values: ["9.0", "10.5"] },
        { name: "硬度", values: ["X", "S", "R"] },
        {
          name: "桿身",
          values: [
            "Fujikura Speeder X Tour (66克)",
            "Fujikura Speeder X Light Tour (54克)",
          ],
        },
      ],
    },
    {
      label: "易打容錯款 (XX)",
      type: "driver",
      options: [
        { name: "度數", values: ["9.0", "10.5"] },
        { name: "硬度", values: ["X", "S", "R"] },
        {
          name: "桿身",
          values: [
            "Fujikura Speeder X Tour (66克)",
            "Fujikura Speeder X Light Tour (54克)",
          ],
        },
      ],
    },
    {
      label: "Fire Mini Driver (2號小Driver)",
      type: "mini_driver",
      options: [
        { name: "度數", values: ["11.5"] },
        { name: "硬度", values: ["X", "S", "R"] },
        {
          name: "桿身",
          values: [
            "Fujikura Speeder X Tour (66克)",
            "Fujikura Speeder X Light Tour (54克)",
          ],
        },
      ],
    },
    {
      label: "Fire 球道木桿 (3號木)",
      type: "3_wood",
      options: [
        { name: "硬度", values: ["X", "S", "R"] },
        {
          name: "桿身",
          values: [
            "Fujikura Speeder X Tour (66克)",
            "Fujikura Speeder X Light Tour (54克)",
          ],
        },
      ],
    },
    {
      label: "Fire 球道木桿 (5號木)",
      type: "5_wood",
      options: [
        { name: "硬度", values: ["X", "S", "R"] },
        {
          name: "桿身",
          values: [
            "Fujikura Speeder X Tour (66克)",
            "Fujikura Speeder X Light Tour (54克)",
          ],
        },
      ],
    },
    {
      label: "Fire 球道木桿 (7號木)",
      type: "7_wood",
      options: [
        { name: "硬度", values: ["X", "S", "R"] },
        {
          name: "桿身",
          values: [
            "Fujikura Speeder X Tour (66克)",
            "Fujikura Speeder X Light Tour (54克)",
          ],
        },
      ],
    },
    {
      label: "Fujikura Speeder X Tour (66克)",
      type: "accessory",
      options: [{ name: "硬度", values: ["R", "S", "X"] }],
    },
    {
      label: "Fujikura Speeder X Light Tour (54克)",
      type: "accessory",
      options: [{ name: "硬度", values: ["R", "S", "X"] }],
    },
  ],
  "Precision Pro": [
    {
      label: "選手高階版 Titan",
      type: "accessory",
      options: [
        { name: "樣式", values: ["Ryder Cup- 歐洲款", "Ryder Cup- 美國款"] },
      ],
    },
    {
      label: "個性潮版本NX10",
      type: "accessory",
      options: [
        {
          name: "樣式",
          values: ["John Daly款", "我打7字頭款", "骷髏頭", "白色經典款"],
        },
      ],
    },
    {
      label: "輕量版NX9",
      type: "accessory",
      options: [{ name: "樣式", values: ["白色款", "黑色款"] }],
    },
  ],
  "Royal Albartross": [
    {
      label: "男鞋 (Men's Shoes)",
      type: "shoes",
      options: [
        { name: "尺寸", values: ["US8", "US9", "US10", "US11", "US12"] },
      ],
    },
    {
      label: "女鞋 (Women's Shoes)",
      type: "shoes",
      options: [
        { name: "尺寸", values: ["US5", "US6", "US7", "US8", "US9"] },
      ],
    },
    {
      label: "男生手套 (Men's Gloves)",
      type: "gloves",
      options: [
        { name: "尺寸", values: ["S", "M", "ML", "L", "XL"] },
      ],
    },
    {
      label: "女生手套 (Women's Gloves)",
      type: "gloves",
      options: [
        { name: "手", values: ["左手", "右手"] },
        { name: "尺寸", values: ["S", "M", "L"] },
      ],
    },
  ],
};
